import Vue from 'vue';
import store from '../store';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Workplace from '../views/Workplace.vue';
import Archive from '../views/Archive.vue';
import Settings from '../views/Settings.vue';
import Employee from '../views/Employee.vue';
import NoRights from '../views/NoRights.vue';
import VisitsApproval from '../views/VisitsApproval.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/approval',
    name: 'VisitsApproval',
    component: VisitsApproval,
  },
  {
    path: '/workplace',
    name: 'Workplace',
    component: Workplace,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/archive',
    name: 'Archive',
    component: Archive,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/employee',
    name: 'Employee',
    component: Employee,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/norights',
    name: 'norights',
    component: NoRights,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    store
      .dispatch('checkLogin')
      .then(() => {
        // console.log('router_login_OK:');
        next();
        return;
      })
      .catch((err) => {
        switch (err) {
          case 'noSession':
            store.commit('globalMessage', 'Session expired');
            break;
          case 'noTerms':
            store.commit('globalMessage', 'Terms not accepted');
            break;
        }
        router.push('/');
      });
  } else {
    next();
  }
});

export default router;
